import { SettingsIcon } from "@xola/icons";
import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { SecondaryButton } from "../../components/Common/SecondaryButton";
import { DigitalWaiversList } from "../../components/Customers/DigitalWaivers/DigitalWaiversList";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const DigitalWaiversPage = () => {
    const history = useHistory();
    const handleClick = () => {
        history.push("/customers/digitalWaivers");
    };

    const handleClickOnSettings = () => {
        history.push("/customers/digitalWaivers/settings");
    };

    return (
        <Page title="Digital Waivers">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Digital Waivers</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <SecondaryButton icon={<SettingsIcon />} onClick={handleClickOnSettings}>
                        Digital Waiver Settings
                    </SecondaryButton>
                </HeaderToolbar>

                <ColumnLayout.Fill>{(height) => <DigitalWaiversList height={height} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
